<template>
    <div class="sidebar">
        <ul>
            <li></li>
            <router-link to="/admin" class="link" v-show="isKyc">
                <li
                    @click="current = '/admin'"
                    :class="{ active: current == '/admin' }"
                    @mouseover="imgDashboard = dasboard"
                    @mouseleave="imgDashboard = require('@/assets/iconImage/Asset79.png')"
                >
                    <img src="@/assets/icons/6a.svg" class="img-sidbar" />
                    Dashboard
                </li>
            </router-link>
            <router-link to="/nsb-baru" class="link" v-show="isKyc || isUser">
                <li @click="current = '/nsb-baru'" :class="{ active: current == '/nsb-baru' }">
                    <img src="@/assets/icons/1a.svg" class="img-sidbar" />
                    Nasabah Baru
                </li>
            </router-link>
            <router-link to="/nsb-terdaftar" class="link" v-show="isKyc && checkAccess('get-list')">
                <li @click="current = '/nsb-terdaftar'" :class="{ active: current == '/nsb-terdaftar' }">
                    <img src="@/assets/icons/4a.svg" class="img-sidbar" />
                    Nasabah Terdaftar
                </li>
            </router-link>
            <router-link to="/nsb-reject" class="link" v-show="isKyc && checkAccess('get-list')">
                <li @click="current = '/nsb-reject'" :class="{ active: current == '/nsb-reject' }">
                    <img src="@/assets/icons/2a.svg" class="img-sidbar" />
                    Nasabah Reject
                </li>
            </router-link>
            <router-link to="/nsb-blacklist" class="link" v-show="isKyc && checkAccess('get-list')">
                <li @click="current = '/nsb-blacklist'" :class="{ active: current == '/nsb-blacklist' }">
                    <img src="@/assets/icons/3a.svg" class="img-sidbar" />
                    <span>Nasabah Blacklist</span>
                </li>
            </router-link>
            <router-link to="/nsb-deposit" class="link" v-show="isDeposit && checkAccess('get-list')">
                <li @click="current = '/nsb-deposit'" :class="{ active: current == '/nsb-deposit' }">
                    <img src="@/assets/icons/10a.svg" class="img-sidbar" />
                    <span>Nasabah Deposit</span>
                </li>
            </router-link>
            <router-link to="/nsb-withdrawal" class="link" v-show="isWithdrawal">
                <li @click="current = '/nsb-withdrawal'" :class="{ active: current == '/nsb-withdrawal' }">
                    <img src="@/assets/icons/9a.svg" class="img-sidbar" />
                    <span>Nasabah Withdrawal</span>
                </li>
            </router-link>

            <!-- <li>
        <div @click="toggle(0)" class="menu-eksternal">
          Eksternal Platform
          <b-icon-chevron-down></b-icon-chevron-down>
        </div>
        <ul class="sub-menu">
          <router-link to="/nsb-eksternal">
            <li @click="current = '/nsb-eksternal'" :class="{ active: current == '/nsb-eksternal' }">Basic Register</li>
          </router-link>
          <router-link to="/esp-kyc"><li @click="current = '/esp-kyc'" :class="{ active: current == '/esp-kyc' }">Register KYC</li></router-link>
          <router-link to="/esp-terdaftar"><li :class="{ active: current == '/esp-terdaftar' }" @click="current = '/esp-terdaftar'">Terdaftar</li></router-link>
        </ul>
      </li> -->

            <li @click="logout"><img src="@/assets/icons/5b.svg" class="img-sidbar img-sidbar-square" />Logout</li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            current: "",
            hover: false,
            dasboard: require("@/assets/iconImage/dashboard_active.png"),
            imgDashboard: require("@/assets/iconImage/Asset79.png"),
            iconLogout: require("@/assets/iconImage/logout_inactive.png"),
            iconNsbTer: require("@/assets/iconImage/nasabah_terdaftar_inactive.png"),
            iconNsbBar: require("@/assets/iconImage/nasabah_baru_inactive.png"),
            iconNsbRjk: require("@/assets/iconImage/nasabah_reject_inactive.png"),
            iconNsbBlk: require("@/assets/iconImage/nasabah_blacklist_inactive.png"),
            service_access: localStorage.getItem("access"),
            isKyc: false,
            isDeposit: false,
            isWithdrawal: false,
            isUser: false,
            accesSuperadmin: false,
        };
    },
    mounted() {
        this.isKyc = this.checkValue("kyc");
        this.isDeposit = this.checkValue("deposit-confirmation");
        this.isWithdrawal = this.checkValue("withdrawal");
        this.isUser = this.checkValue("user");
        let role = localStorage.getItem("role");
        if (role == "0") {
            this.accesSuperadmin = true;
        } else {
            this.accesSuperadmin = false;
        }
    },
    methods: {
        checkAccess(value) {
            let service_access = localStorage.getItem("access");
            let dataAcces = JSON.parse(service_access);
            let returnValue = this.isAccess;
            for (let i = 0; i < dataAcces.length; i++) {
                let access = dataAcces[i].access;
                for (let j = 0; j < access.length; j++) {
                    if (access[j] == value) {
                        returnValue = true;
                    }
                }
            }
            return returnValue;
        },
        checkValue(value) {
            let dataAcces = JSON.parse(this.service_access);
            let returnValue = false;
            for (let i = 0; i < dataAcces.length; i++) {
                if (dataAcces[i].service == value) {
                    returnValue = true;
                }
            }
            return returnValue;
        },
        toggle(e) {
            var elems = document.getElementsByClassName("sub-menu");
            if (elems[e].classList.value === "sub-menu") {
                elems[e].classList.add("active-menu");
            } else {
                elems[e].classList = "sub-menu";
            }
        },
        logout() {
            this.$store.dispatch("logout").then(() => {
                this.$router.go("/home");
            });
        },
    },
    computed: {
        checkRole() {
            let role = localStorage.getItem("role");
            if (role) {
                return role;
            } else {
                return null;
            }
        },
    },
};
</script>

<style scoped>
.sidebar {
    width: 219px;
}

ul {
    padding: 0;
}

ul li {
    list-style: none;
    line-height: 2.5;
}

li {
    /* height: 60px; */
    align-items: center;
    font-size: 14px;
    padding: 12px 25px;
    cursor: pointer;
    color: #707070;
}

li:hover {
    /* background-color: rgba(230, 230, 230, 0.25);  */
    color: #6454f0;
    /* position: relative; */
}

.sub-menu {
    padding: 0 0 0 15px;
    display: none;
    transition: ease-out 0.5s;
}

a .router-link-active li {
    background-color: rgba(230, 230, 230, 0.25);
    color: #6454f0;
}

.active-menu {
    display: block;
}

.active {
    background-color: rgba(230, 230, 230, 0.25);
    color: #6454f0;
    position: relative;
}

.active::before {
    content: "";
    position: absolute;
    width: 5px;
    height: 100%;
    background: #6454f0;
    left: 0;
    top: 0px;
}

.link:hover {
    text-decoration: none;
}

.icon-sidebar {
    font-size: 20px;
    margin-right: 10px;
}

.img-sidbar {
    width: 20px;
    margin-right: 10px;
    vertical-align: text-top;
}

.img-sidbar-square {
    width: 16px;
    margin-right: 10px;
    vertical-align: text-top;
}

.menu-eksternal {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
